require('../insuranceRequestDetails/insuranceRequestDetailsTabs.scss');
require('./table.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const classnames = require('classnames');
const { get } = require('lodash');

// @ utilities
const { EURO_SYMBOL } = require('constants/index');
const { formatAmount } = require('utilities/currencyHelper');
const { formatText, getLanguage, FormattedText } = require('core/i18n').i18n;

// @ constants
const { PLANS, VALUE_TYPES, COVERAGES_CONFIGURABLE } = require('../../insuranceConstants/insuranceRequestHome');

// @ Components
const { OKTable } = require('commonsComponents/OKTable');
const { OKTableRow } = require('commonsComponents/OKTableRow');
const { OKTableCell } = require('commonsComponents/OKTableCell');
const { LoadingSection } = require('commonsComponents/loadingSection');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const CoverageHeaderButtonsCC = require('./coverageHeaderButtonsCC');

// @ Component Constants
const basicPlan = PLANS.BASIC;
const mediumPlan = PLANS.MEDIUM;
const highPlan = PLANS.HIGH;
const mediumPlanKey = mediumPlan.toLowerCase();
const basicPlanKey = basicPlan.toLowerCase();
const highPlanKey = highPlan.toLowerCase();

class Coverages extends React.Component {
    constructor(props) {
        super(props);
        this.buildInputs = this.buildInputs.bind(this);
        this.navigationBetweenPlans = this.navigationBetweenPlans.bind(this);
        this.buildShowRowTooltip = this.buildShowRowTooltip.bind(this);
    }

    componentDidMount() {
        this.changeToDefaultPlan()
    }

    componentWillUnmount() {
        this.changeToDefaultPlan()
    }

    changeToDefaultPlan() {
        const { isRelated } = this.props
        if (!isRelated) {
            const { onhandleChangeSelectedPlanInStateComponent } = this.props
            onhandleChangeSelectedPlanInStateComponent(PLANS.BASIC, false)
        }
    }

    contentAndcontinentValue(type, value) {
        const language = getLanguage();

        let cellValue;

        if (type === VALUE_TYPES.PERCENTAGE) {
            const percentageValue = formatText('insuranceRequestHome-step3PercentageValue', [value]);
            cellValue = <span className="coverages-detail-table-cc__value-number">{percentageValue}</span>;
        } else if (type === VALUE_TYPES.MONEY) {
            const importValue = formatAmount(value, language, 0);
            cellValue = <span className="coverages-detail-table-cc__value-number">{`${importValue} ${EURO_SYMBOL}`}</span>;
        } else if (type === VALUE_TYPES.NUMBER) {
            cellValue = <span className="coverages-detail-table-cc__value-number">{value}</span>;
        } else if (type === VALUE_TYPES.CHECK && value === '1') {
            cellValue = (
                <span className="coverages-detail-table-cc__icon-container">
                    <i className="icon-checkmark coverages-detail-table-cc__icon-check" />
                </span>
            );
        } else {
            cellValue = (
                <span className="coverages-detail-table-cc__icon-container">
                    <i className="icon-cerrar coverages-detail-table-cc__icon-close" />
                </span>
            );
        }

        return cellValue;
    }

    buildOneColumnCell(continentDataValue) {
        return (
            <OKTableCell className="coverages-detail-table-cc__value coverages-detail-table-cc__value-one-cell">
                {continentDataValue}
            </OKTableCell>
        )
    }

    componentsWithoutWrapper(componentsArray) {
        const componentWithKeys = componentsArray.map((planItem, index) => {
            var newPlansObject = Object.assign({}, planItem);
            newPlansObject.key = index;
            return newPlansObject;
        })

        return componentWithKeys
    }

    buildTwoColumnCell(continentDataValue, contentDataValue, contentCommentValue) {

        const continentDataValueCell = (
            <OKTableCell key={''} className="coverages-detail-table-cc__value coverages-detail-table-cc__value-no-borderbottom">
                {continentDataValue}
            </OKTableCell>
        );
        const contentDataValueCell = (
            <OKTableCell key={''} className="coverages-detail-table-cc__value coverages-detail-table-cc__value-no-borderbottom">
                <span className="coverages-detail-table-cc__value-text">
                    {contentDataValue}
                    <span className="coverages-detail-table-cc__comment">{contentCommentValue}</span>
                </span>
            </OKTableCell>
        );
        const tableCells = [
            continentDataValueCell,
            contentDataValueCell
        ]

        return this.componentsWithoutWrapper(tableCells)
    }

    getClassNameForTableCell(coverage, childItem = false) {
        const coverageConfigurable = COVERAGES_CONFIGURABLE[coverage];
        const isCoverageConfigurable = coverageConfigurable ? true : false;
        const cellClass = childItem ?
            'coverages-detail-table-cc__category-child coverages-detail-table-cc__category-child-no-borderbottom' :
            'coverages-detail-table-cc__content';
        return classnames(cellClass, {
            'coverages-detail-table-cc__content-configurable': isCoverageConfigurable,
            'coverages-detail-table-cc__category-child-configurable': isCoverageConfigurable && childItem,
        });
    }

    getContentAndContinentCells(item, nameValue) {
        const continentType = get(item, 'continent.type', null);
        const contentType = get(item, 'content.type', null);
        const continentValue = get(item, 'continent.value', null);
        const contentValue = get(item, 'content.value', null);

        if (continentType && continentValue && contentType && contentValue) {
            const continentDataValue = this.contentAndcontinentValue(continentType, continentValue);
            const contentDataValue = this.contentAndcontinentValue(contentType, contentValue);
            const areContinentAndContentValueEquals = continentType !== contentType && continentValue !== contentValue;
            const contentCommentValidation = get(item, 'content.comment', false);
            let contentCommentValue = '';

            if (contentCommentValidation) {
                const commentValue = get(item, 'content.commentValue', false);
                if (commentValue) {
                    const language = getLanguage();
                    const moneyValue = formatAmount(commentValue, language, 0);
                    const maxComment = formatText('insuranceRequestHome-step3details_comment_for_money');
                    contentCommentValue = `(${maxComment} ${moneyValue} ${EURO_SYMBOL})`;
                } else {
                    contentCommentValue = formatText(`insuranceRequestHome-step3details_${nameValue}_comment_content`);
                }
            }

            return contentCommentValidation
                || continentType !== VALUE_TYPES.MONEY
                || areContinentAndContentValueEquals
                ? this.buildTwoColumnCell(continentDataValue, contentDataValue, contentCommentValue)
                : this.buildOneColumnCell(continentDataValue);
        } else {
            return null;
        }
    }

    buildChildrenRows(item, rowName, idItem) {
        const { children, name } = item;
        const nameParentValue = !!name ? name.toLowerCase() : null;

        const childrenData = children.map((data, idx) => {
            const nameValue = data.name.toLowerCase();
            const nameLabel = formatText(`insuranceRequestHome-step3details_${nameValue}`);
            const renderCells = this.getContentAndContinentCells(data, nameValue);

            return (
                <OKTableRow className="coverages-detail-table-cc-children__category-row coverages-detail-table-cc-children__category-row-no-borderbottom" key={idx}>
                    <OKTableCell className={this.getClassNameForTableCell(data.name, true)}>
                        <span className="coverages-detail-table-cc__category-row-name-label">
                            {nameLabel}
                        </span>
                    </OKTableCell>
                    {renderCells}
                </OKTableRow>
            )
        });

        const renderCells = this.getContentAndContinentCells(item, nameParentValue);

        const rowTitleClass = classnames('coverages-detail-table-cc-children__category-row coverages-detail-table-cc-children__category-row--title', {
            'coverages-detail-table-cc-children__category-row--is-odd': (idItem + 1) % 2
        })

        return (
            <OKTable className="coverages-detail-table-cc-children">
                <tbody className="coverages-detail-table-cc-children__body">
                    <OKTableRow className={rowTitleClass}>
                        <OKTableCell className={this.getClassNameForTableCell(name)} colSpan={renderCells !== null ? 1 : 4}>
                            <span className="coverages-detail-table-cc__category-row-name-label">
                                {rowName}
                            </span>
                        </OKTableCell>
                        {renderCells}
                    </OKTableRow>
                    {childrenData}
                </tbody>
            </OKTable>
        );

    }

    buildShowRowTooltip(label, alternativeIcon = false) {
        return (
            <OKTooltip
                alternativeIcon={alternativeIcon}
                content={label}
                offset={[0, -5]}
            />
        );
    }

    buildTable(planState) {
        const { propertyInformation, selectedPlan, immInsuranceWizardStep, didPlanChangeIndetailTable } = this.props;
        const livingPlace = propertyInformation.get('propertyUsage');
        const livingPlaceType = livingPlace.toLowerCase();
        const livingPlaceTitle = formatText(`insuranceRequestHome-step3${livingPlaceType}_property`);
        const continentTitle = formatText('insuranceRequestHome-step3ContinentReform');
        const contentTitle = formatText('insuranceRequestHome-step3ContentDetails');
        const insurancePlan = immInsuranceWizardStep.get('insurancePlan');
        const planPickedTable = planState.map((item, idx) => {
            const nameValue = !!item.name ? item.name.toLowerCase() : null;
            const renderCells = this.getContentAndContinentCells(item, nameValue);
            const dataValidation = !!nameValue && renderCells !== null;
            const childrenValidationData = !!item.children ? item.children.length > 0 : null;
            const planValidation = didPlanChangeIndetailTable ? selectedPlan : insurancePlan;
            if (dataValidation || childrenValidationData) {
                let nameLabel = formatText(`insuranceRequestHome-step3details_${nameValue}`);
                const isBasicValue = nameValue === 'basic';
                const showAlternativeIcon = isBasicValue && livingPlace !== 'PRINCIPAL' && (planValidation && planValidation !== 'BASIC') || false;
                let tooltip = null;

                if (isBasicValue) {
                    const tooltipLabel = <FormattedText value={`insuranceRequestHome-step3${nameValue}Tooltip`} />;
                    tooltip = this.buildShowRowTooltip(tooltipLabel, showAlternativeIcon);
                }

                if (childrenValidationData) {
                    const childrenData = this.buildChildrenRows(item, nameLabel, idx);
                    return (
                        <OKTableRow key={idx}>
                            <OKTableCell className="coverages-detail-table-cc-children__cell" colSpan={3}>
                                {childrenData}
                            </OKTableCell>
                        </OKTableRow>
                    )
                } else {
                    return (
                        <OKTableRow className="coverages-detail-table-cc__category-row" key={idx}>
                            <OKTableCell className={this.getClassNameForTableCell(item.name)}>
                                <span className="coverages-detail-table-cc__category-row-name-label">{nameLabel}</span> {tooltip}
                            </OKTableCell>
                            {renderCells}
                        </OKTableRow>
                    );
                }
            }
        });

        return (
            <OKTable className="coverages-detail-table-cc">
                <thead className="coverages-detail-table-cc__header">
                    <tr>
                        <OKTableCell asHeader={true} className="coverages-detail-table-cc__main">{livingPlaceTitle}</OKTableCell>
                        <OKTableCell asHeader={true} className="coverages-detail-table-cc__secondary">{continentTitle}</OKTableCell>
                        <OKTableCell asHeader={true} className="coverages-detail-table-cc__secondary">{contentTitle}</OKTableCell>
                    </tr>
                </thead>
                <tbody className="coverages-detail-table-cc__body">
                    {planPickedTable}
                </tbody>
            </OKTable>
        )
    }

    buildInputs(id, value, defaultChecked) {
        const { onhandleChangeSelectedPlanInStateComponent } = this.props;
        return (
            <input
                id={id}
                type="radio"
                name="coverages-details-plans-tab"
                className={`coverages-details-plans__${id}`}
                value={value}
                defaultChecked={defaultChecked}
                onChange={() => onhandleChangeSelectedPlanInStateComponent(value)}
            />
        )
    }

    navigationBetweenPlans() {
        const { 
            immInsuranceWizardStep,
            insuranceUsabilityImprovementsFlag,
         } = this.props;

        const selectedPlan = immInsuranceWizardStep.get('insurancePlan');

        const selectBasicPlan = !selectedPlan || selectedPlan === basicPlan;
        const selectMediumPlan = selectedPlan === mediumPlan;
        const selechighPlan = selectedPlan === highPlan;

        const navigationPlans = [
            this.buildInputs(basicPlanKey, basicPlan, selectBasicPlan),
            this.buildInputs(mediumPlanKey, mediumPlan, selectMediumPlan),
            this.buildInputs(highPlanKey, highPlan, selechighPlan),
            <nav className="coverages-details-plans__nav coverages-details-plans__desktop" key={''}>
                <ul className="coverages-details-plans__list">
                    <CoverageHeaderButtonsCC
                        immInsuranceWizardStep={immInsuranceWizardStep}
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        plan={PLANS.BASIC}
                    />
                    <CoverageHeaderButtonsCC
                        immInsuranceWizardStep={immInsuranceWizardStep}
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        plan={PLANS.MEDIUM}
                    />
                    <CoverageHeaderButtonsCC
                        immInsuranceWizardStep={immInsuranceWizardStep}
                        insuranceUsabilityImprovementsFlag={insuranceUsabilityImprovementsFlag}
                        plan={PLANS.HIGH}
                    />
                </ul>
            </nav>
        ]

        return this.componentsWithoutWrapper(navigationPlans)
    }


    render() {
        const { immInsuranceWizardStep, extraClass, showHeaderTabs, chosenPlan } = this.props;

        if (
            !immInsuranceWizardStep.getIn(['coveragesDetailsBasicData', 'guarantee']) &&
            !immInsuranceWizardStep.getIn(['coveragesDetailsMediumData', 'guarantee']) &&
            !immInsuranceWizardStep.getIn(['coveragesDetailsHighData', 'guarantee'])
        ) {
            return <LoadingSection />;
        }

        const basicPlanDetails = immInsuranceWizardStep.getIn(['coveragesDetailsBasicData', 'guarantee']).toJS();
        const mediumPlanDetails = immInsuranceWizardStep.getIn(['coveragesDetailsMediumData', 'guarantee']).toJS();
        const highPlanDetails = immInsuranceWizardStep.getIn(['coveragesDetailsHighData', 'guarantee']).toJS();
        const buildBasicTable = this.buildTable(basicPlanDetails);
        const buildMediumTable = this.buildTable(mediumPlanDetails);
        const buildHighTable = this.buildTable(highPlanDetails);
        const tableExtraClass = classnames('row coverages-details-plans', extraClass);
        const plans = {
            BASIC: this.buildInputs(basicPlanKey, basicPlan, true),
            MEDIUM: this.buildInputs(mediumPlanKey, mediumPlan, true),
            HIGH: this.buildInputs(highPlanKey, highPlan, true)
        };
        const showChoosenPlan = plans[chosenPlan];
        const headerNavigation = showHeaderTabs ? this.navigationBetweenPlans() : showChoosenPlan;
        return (
            <div className={tableExtraClass}>
                {headerNavigation}
                <section className="coverages-details-plans__main-container">
                    <div className="coverages-details-plans__basic">
                        <div className="coverages-details-plans__table-container">
                            {buildBasicTable}
                        </div>
                    </div>
                    <div className="coverages-details-plans__medium">
                        <div className="coverages-details-plans__table-container">
                            {buildMediumTable}
                        </div>
                    </div>
                    <div className="coverages-details-plans__high">
                        <div className="coverages-details-plans__table-container">
                            {buildHighTable}
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}

Coverages.propTypes = {
    immInsuranceState: PropTypes.object,
    immInsuranceWizardStep: PropTypes.object.isRequired,
    insuranceUsabilityImprovementsFlag: PropTypes.bool,
    propertyInformation: PropTypes.object.isRequired,
    onhandleChangeSelectedPlanInStateComponent: PropTypes.func,
    showHeaderTabs: PropTypes.bool,
    extraClass: PropTypes.string,
    chosenPlan: PropTypes.string,
    isRelated: PropTypes.bool,
    selectedPlan: PropTypes.string,
    didPlanChangeIndetailTable: PropTypes.bool,
};

Coverages.defaultProps = {
    showHeaderTabs: true,
    extraClass: '',
    chosenPlan: '',
    isRelated: false,
    onhandleChangeSelectedPlanInStateComponent: () => { }
};

module.exports = Coverages;
